"use strict";

var moment = require('moment');
module.exports = /*@ngInject*/function () {
  var messageMap = {
    'a few seconds ago': 'today',
    'in a day': 'tomorrow'
  };
  return function (input, prefix) {
    // eslint-disable-next-line no-param-reassign
    input = moment(input).endOf('date');
    var message = input.from(moment().endOf('date'));
    return prefix ? "".concat(prefix, " ").concat(messageMap[message] || message) : "".concat(messageMap[message] || message);
  };
};